module.exports = __webpack_public_path__ + "img/tel.896234e1.svg";